import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteAttributeGroup = async (itemId: string, externalSystemId: string): Promise<void> => {
  const url = `${API_URL}/items/${itemId}/rules/${externalSystemId}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (res.status === Status.BAD_REQUEST || res.ok === false) {
    throw new Error('Unable to delete attribute group. Please try again');
  }
};
